import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Breadcrumbs from "../../components/pageProps/Breadcrumbs";

const About = () => {
  const location = useLocation();
  const [prevLocation, setPrevLocation] = useState("");
  useEffect(() => {
    setPrevLocation(location.state.data);
  }, [location]);
  return (
    <div className="max-w-container mx-auto px-4">
      <Breadcrumbs title="About" prevLocation={prevLocation} />
      <div className="pb-10">
        <h1 className="max-w-[600px] text-base text-lightText mb-2">
          <span className="text-primeColor font-semibold text-lg">JOHN appliances</span>{" "}
          JOHN appliances is your go-to appliance repair shop, specializing in refrigerators, microwave ovens, and more. Our expert technicians provide fast, reliable, and affordable repairs for all major brands. Whether your fridge isn’t cooling or your microwave isn’t heating, we’ve got you covered!

📞 Call us:+254798406401  | 📍 Location: Nairobi,Kenya
        </h1>
        <Link to="/shop">
          <button className="w-52 h-10 bg-primeColor text-white hover:bg-black duration-300">
            Continue Shopping
          </button>
        </Link>
      </div>
    </div>
  );
};

export default About;
